import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { farmUpdateAction } from "../../../modules/farmManagement/action";
import MainFarmForm from "../../public/MainFarmForm";


class EditMainFarm extends Component {
  state = { successMessage: "" };

  handleSubmit = farmInfo => {
    farmInfo.id = this.props.selectedFarm.id;
    this.props.farmUpdateAction(farmInfo);
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.farmUpdated && nextProps.farmUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  render() {
    const { successMessage } = this.state;
    if (successMessage) {
      return <Redirect to="/farmmanagement" />;
    }
    return (
      <MainFarmForm
        farmInfo={this.props.selectedFarm}
        formLabel="Main Sub Farm"
        buttonLabel="Update"
        handleSubmit={this.handleSubmit}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    selectedFarm: state.FarmManagementReducer.selectedFarm,
    farmUpdated: state.FarmManagementReducer.farmUpdated
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ farmUpdateAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditMainFarm);



// WEBPACK FOOTER //
// ./src/components/private/FarmManagment/EditMainFarm.js